import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="workers--worker"
export default class extends Controller {
  static targets = [
    "table",
    "form",
    "tab",
    "pane"
  ]

  connect() {
    this.updateBreadcrumb();
  }

  edit(event) {
    const badge = this.tableTarget.querySelector('tr span.badge');
    const row = event.currentTarget.closest('tr');
    const secondCell = row.children[1];

    if (badge && secondCell) {
      secondCell.append(badge);
      this.selectedWorker(event);
    }
  }

  updateBreadcrumb(event) {
    const td = document.querySelector('.btn.sm.active').closest('tr').children[1];
    const name = [...td.childNodes].find(node => node.nodeType === Node.TEXT_NODE)?.textContent.trim();

    document.querySelector(".master-page .crumb").innerHTML = `マスタ ＞ 職員マスタ ＞ ${name}`;
  }

  switchTab(event) {
    const selected = event.currentTarget.dataset.tab

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tab === selected)
    })

    this.paneTargets.forEach(pane => {
      pane.style.display = pane.dataset.pane === selected ? "block" : "none"
    })
  }

  cloneEntry(event) {
    const entry = event.currentTarget;
    const { type, id } = entry.dataset;

    let cloneButtonId = "";

    if (type === "PersonalWage") {
      cloneButtonId = "personal-wage-clone-btn";
    } else if (type === "PersonalWorkTypeWage") {
      cloneButtonId = "personal-work-type-wage-clone-btn";
    }

    const link = document.getElementById(cloneButtonId);

    if (!!link) {
      link.href = link.dataset.defaultUrl.replace("DEFAULT", id);

      const container = entry.closest("[data-pane]");
      const badge     = container.querySelector("tbody .badge");

      const currentBadgeTd   = badge.closest("td");
      const currentBadgeTr   = currentBadgeTd.closest("tr");
      const badgeColumnIndex = Array.from(currentBadgeTr.cells).indexOf(currentBadgeTd);;

      entry.cells[badgeColumnIndex].prepend(badge);
    }
  }

  selectedWorker(event) {
    this.element.querySelectorAll('#empTable .active').forEach(b => b.classList.remove('active'))
    this.element.querySelectorAll("#empTable .btn")
      .forEach(btn => btn.classList.remove("active"))
    event.currentTarget.classList.add("active")
    this.updateBreadcrumb(event)
  }
}
